const navigationItems = [
  {
    id: 1,
    title: 'الصفحة الرئيسية',
    key: 'home',
    ability: 'Home',
    to: '/home',
    icon: { icon: 'mdi mdi-store' },
    subItems: []
  }
]

export default navigationItems
